import { useMemo } from 'react'
import { getBeamWallOverlapGuids } from './utils'

const useWallsWithBeamOverlap = (walls: ShapeObject[], beams: ShapeObjectLine[]) => {
  return useMemo(() => getBeamWallOverlapGuids(walls, beams), [walls, beams])
}

export default useWallsWithBeamOverlap
